// Tuft.jo shared toast notification system — used by workshop booking and elsewhere.
(function () {
  const ensureToastContainer = () => {
    let c = document.getElementById('tj-toasts');
    if (!c) {
      c = document.createElement('div');
      c.id = 'tj-toasts';
      document.body.appendChild(c);
    }
    return c;
  };
  window.tjToast = (msg, opts = {}) => {
    const c = ensureToastContainer();
    const el = document.createElement('div');
    el.className = 'tj-toast' + (opts.error ? ' err' : '');
    el.innerHTML = `
      <span class="ico">${opts.error ? '!' : '✓'}</span>
      <span class="msg">${msg}</span>
      ${opts.action ? `<button class="act">${opts.action.label}</button>` : ''}
    `;
    c.appendChild(el);
    requestAnimationFrame(() => el.classList.add('in'));
    if (opts.action) {
      el.querySelector('.act').addEventListener('click', () => {
        opts.action.onClick();
        el.classList.remove('in');
        setTimeout(() => el.remove(), 250);
      });
    }
    setTimeout(() => { el.classList.remove('in'); setTimeout(() => el.remove(), 250); }, opts.duration || 3200);
  };
})();
